import { onlineManager, useQueryClient } from '@tanstack/react-query';
import { DataQueryKey, UseDataQueryKey } from '../../../../hooks/useDataQuery/dataQuery.types';
import { getFindOrderConditionsKey } from '../../../../services/modules/orderCondition/orderCondition.keys';
import { getFindProductGridKey } from '../../../../services/modules/product-grid/product-grid.keys';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import useCalculateSummary from '../../hooks/useCalculateSummary';
import { IValidateOrUpdatePricesItem } from '../types/forceUpdateOrder.types';

const useUpdateOrderInvalidations = () => {
  const queryClient = useQueryClient();
  const { team } = useApplicationContext();
  const { calculateSummary } = useCalculateSummary();

  const refetchQueries = (queryKey: UseDataQueryKey) =>
    queryClient.refetchQueries({ queryKey: [team?.id, ...queryKey] });

  const invalidateOrderItemsGrid = (orderId: string, items: IValidateOrUpdatePricesItem[]) => {
    items.forEach((item) => {
      const queryKey = getFindProductGridKey({
        orderId,
        availability: item.availability,
        productColorId: item.productColorId as string,
        deliveryWindowId: item.deliveryWindowId,
        isOfflineMode: !onlineManager.isOnline(),
      });
      refetchQueries(queryKey);
    });
  };

  const invalidateOrderConditions = (orderId: string) => {
    const queryKey = getFindOrderConditionsKey({ orderId });
    refetchQueries(queryKey);
  };

  const invalidateOrderConditionsValidate = (orderId: string) => {
    const queryKey: UseDataQueryKey = [DataQueryKey.ORDER_VALIDATE_CONDITIONS, orderId];
    refetchQueries(queryKey);
  };

  const invalidateCalculateOrder = () => {
    calculateSummary();
  };

  const invalidateCommonQueries = (orderId: string) => {
    invalidateCalculateOrder();
    invalidateOrderConditionsValidate(orderId);
  };

  return {
    invalidateCommonQueries,
    invalidateOrderItemsGrid,
    invalidateOrderConditions,
  };
};

export default useUpdateOrderInvalidations;
